module.exports = __webpack_public_path__ + "img/t1-4.e07488c9.svg";